import { Message } from "element-ui";

const throttleAt = Object.create(null);

function isNetworkLikeError(error) {
  if (!error) return true;
  if (error.code === "ECONNABORTED") return true;
  return !error.response;
}

function messageFromHttpError(error) {
  const data = error.response && error.response.data;
  if (data && typeof data.msg === "string" && data.msg) {
    return data.msg;
  }
  const status = error.response && error.response.status;
  if (status >= 500) {
    return "服务器异常，请稍后重试";
  }
  return "请求失败，请稍后重试";
}

/**
 * 接口请求失败时提示（网络断开、超时、HTTP 错误等）
 * @param {unknown} error axios 错误对象
 * @param {{ throttleKey?: string, throttleMs?: number }} [options] throttleKey 用于轮询等场景，避免重复弹窗
 */
export function notifyRequestError(error, options = {}) {
  const { throttleKey, throttleMs = 45000 } = options;
  if (throttleKey) {
    const now = Date.now();
    const last = throttleAt[throttleKey] || 0;
    if (now - last < throttleMs) {
      return;
    }
    throttleAt[throttleKey] = now;
  }

  console.error(error);

  if (error && error.code === "ECONNABORTED") {
    Message.error("请求超时，请检查网络后重试");
    return;
  }
  if (isNetworkLikeError(error)) {
    Message.error("网络异常，请检查网络连接后重试");
    return;
  }
  Message.error(messageFromHttpError(error));
}
